<div class="epds_mat_override">
  <div *appSpinner="loading; diameter: 40; color: 'primary'"></div>
    <div [hidden]="!isSearchVisible || loading">
      <ng-container [ngTemplateOutlet]="searchTemplate"></ng-container>
      <ng-container [ngTemplateOutlet]="searchResultTemplate"></ng-container>
    </div>
    @if (isIntervenorFormVisible) {
      <ng-container [ngTemplateOutlet]="intervenorFormTemplate"></ng-container>
    }
</div>

<ng-template #searchTemplate>
  <mat-card>
    <mat-card-header>
      <mat-card-title role="heading" aria-level="1">{{ headerText }}</mat-card-title>
    </mat-card-header>
    <mat-card-content class="no-bottom-pad">
      <form #searchForm="ngForm">
        <div>
          <br/>
          <mat-form-field floatLabel="always" appearance="outline" class="search-field">
            <mat-label>B#</mat-label>
            <div>B-</div>
            <input matInput type="text"
                   name="bNumField" #bNumField="ngModel"
                   [(ngModel)]="bNum" (ngModelChange)="onBNumChange($event)" />
            <mat-error *ngIf="bNumField.invalid" >B# must be 6 characters</mat-error>
          </mat-form-field>
          <button mat-raised-button
                  color="primary" class="spinner-black"
                  [disabled]="bNumField.invalid || searching"
                  (click)="onSearch()">
            <div *appSpinner="searching"></div>
            Search
          </button>
        </div>


        <div [innerHTML]="searchMessage"></div>

        @if (searchNote) {
          <br/>
          <div [innerHTML]="searchNote"></div>
        }
      </form>
    </mat-card-content>
  </mat-card>
</ng-template>

<ng-template #searchResultTemplate>

  <mat-card [style.display]="isSearchVisible ? 'flex' : 'none'">
    <mat-card-content fxLayout="column" class="no-bottom-pad">
      <div fxLayout>
        <div fxLayoutAlign="start" fxFlex="20">
          <mat-form-field floatLabel="always" appearance="outline">
            <mat-label>Filter</mat-label>
            <input matInput type="text" (keyup)="eventFilter($event)" #filterInput>
            <button mat-icon-button *ngIf="filterInput.value" matSuffix aria-label="Clear"
                    (click)="filterInput.value='';eventFilter($event); $event.stopPropagation()">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </div>
        <div fxFlex="80" fxLayoutAlign="end">
          <mat-paginator showFirstLastButtons appPaginationSave
                         [lsKey]="pageLocalStorageKey" [pageSizeOptions]="[5, 10, 25, 50, 100]">
          </mat-paginator>
        </div>
      </div>
      <div class="scrollable-content" [class]="scrollClass">
        <table mat-table [dataSource]="dataSource"
               class="join-request-search-results"
               matSortActive="b_No" matSortDirection="asc" matSort (matSortChange)="onSortChange($event)">

          <ng-container matColumnDef="b_No">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by B-Number">B-Number</th>
            <td mat-cell *matCellDef="let element">{{ element.b_No }}</td>
          </ng-container>

          <ng-container matColumnDef="company_Name">
            <th mat-header-cell *matHeaderCellDef  mat-sort-header sortActionDescription="Sort by Protester">Protester</th>
            <td mat-cell *matCellDef="let element">{{ element.company_Name }}</td>
          </ng-container>

          <ng-container matColumnDef="submission_Date">
            <th mat-header-cell *matHeaderCellDef  mat-sort-header sortActionDescription="Sort by Filing Date">Filing Date</th>
            <td mat-cell *matCellDef="let element">{{ element.submission_Date }}</td>
          </ng-container>

          <ng-container matColumnDef="agency_Name">
            <th mat-header-cell *matHeaderCellDef  mat-sort-header sortActionDescription="Sort by Agency">Agency</th>
            <td mat-cell *matCellDef="let element">{{ element.agency_Name }}</td>
          </ng-container>

          <ng-container matColumnDef="solicitation_No">
            <th mat-header-cell *matHeaderCellDef  mat-sort-header sortActionDescription="Sort by Soliciation Number">Solicitation Number</th>
            <td mat-cell *matCellDef="let element">{{ element.solicitation_No }}</td>
          </ng-container>

          <ng-container matColumnDef="due_Date">
            <th mat-header-cell *matHeaderCellDef  mat-sort-header sortActionDescription="Sort by Due Date">Due Date</th>
            <td mat-cell *matCellDef="let element">{{ element.due_Date }}</td>
          </ng-container>

          <ng-container matColumnDef="request">
            <th mat-header-cell *matHeaderCellDef>{{ requestMessage }}</th>
            <td mat-cell *matCellDef="let element">
              <button mat-raised-button color="primary"
                      (click)="onRequestToIntervene(element)">
                Yes
              </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

          <!-- Row shown when there is no matching data. -->
          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" colspan="5">Loading, no data, or nothing that matches the filter "{{filterInput.value}}"</td>
          </tr>
        </table>
      </div>
    </mat-card-content>
  </mat-card>
</ng-template>

<ng-template #intervenorFormTemplate>
  @if (protestInfoRow) {

    <mat-card>
      <mat-card-content>
        <table aria-label="Table with protest information" role="presentation" fxFlex>
          <colgroup>
            <col style="width: 140px;">
            <col>
          </colgroup>
          <tbody>
          <tr>
            <td><span><strong>B-Number</strong></span></td>
            <td>
                <span [ngClass]="{ 'pending-entry color_warn': !protestInfoRow.b_No  }"
                      [matTooltip]="protestInfoRow.a_No">
                  {{ protestInfoRow.b_No || "pending" }}
                </span>
            </td>
          </tr>
          <tr>
            <td><span><strong>Protester</strong></span></td>
            <td><span>{{ protestInfoRow.company_Name }}</span></td>
          </tr>
          <tr>
            <td><span><strong>Agency</strong></span></td>
            <td><span>{{ protestInfoRow.agency_Name }}</span></td>
          </tr>
          <tr>
            <td><span><strong>Solicitation Number</strong></span></td>
            <td><span>{{ protestInfoRow.solicitation_No }}</span></td>
          </tr>
          </tbody>
        </table>
      </mat-card-content>
    </mat-card>

    <div class="full-height">

      @if (this.typeOfRequest === 'intervene') {
        <app-add-intervenor class="full-height"
                            [visible]="isIntervenorFormVisible"
                            [a_No]="protestInfoRow.a_No"
                            (onSubmit)="onIntervenorSubmit()"
                            (onCancel)="onIntervenorCancel()">
        </app-add-intervenor>
      } @else {
        <app-add-agency-rep class="full-height"
                            [a_No]="protestInfoRow.a_No"
                            (onSubmit)="onIntervenorSubmit()"
                            (onCancel)="onIntervenorCancel()">

        </app-add-agency-rep>
      }
    </div>
  }
</ng-template>
